import { CounterpartyProfile } from "@wingspanhq/wingspan-api-sdk";

/**
 * The subset of a v3 counterparty (Payer or Payee) a display name is derived
 * from — both models share the same `profile` / `email` / `id` fields.
 */
export interface CounterpartyDisplayNameInput {
  profile?: CounterpartyProfile;
  email?: string;
  id?: string;
}

/**
 * Resolves a human-readable display name for a v3 counterparty (Payer or Payee):
 * the backend-resolved `profile.displayName` wins, then the company DBA, then the
 * contact email, and finally the id as a stable fallback.
 */
export const selectorCounterpartyDisplayName = (
  counterparty: CounterpartyDisplayNameInput
): string => {
  const displayName = counterparty.profile?.displayName?.trim();
  if (displayName) {
    return displayName;
  }

  const company = counterparty.profile?.company?.doingBusinessAs?.trim();
  if (company) {
    return company;
  }

  return counterparty.email || counterparty.id || "";
};
